/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toReportProps, toRankingUserProps } from './translator/report'
import { toQuery, toQueryProps } from './translator/query'
import { GetReport, FetchRanking } from '@/infrastructure/network/Monitaro/requests/report'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'

export default class Report extends MonitaroGatewayBase {
  async GetReport(query?: any) {
    const { report } = await this.apiClient.request(new GetReport(query))
    return toReportProps(report)
  }

  async FetchRanking(type: string, query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchRanking(type, toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.rankings.map((prop) => toRankingUserProps(prop)),
      query: toQueryProps(response.query)
    })
  }
}
